import { isSnapshotsSortField } from "@custom-types/type-guards";
import { convertGridSortModelToSortBy } from "@utils/sort-utils";
import { DEFAULT_SNAPSHOTS_SORT_BY } from "@pages/project-details/project-snapshots/snapshots-table-constants";
/**
 * @returns a valid snapshots `sortBy` option from the passed GridSortModel
 * @param gridSortModel Snapshots table sort model
 */
export function getSortByFromGridSortModel(gridSortModel) {
  return convertGridSortModelToSortBy(gridSortModel, {
    defaultSortBy: DEFAULT_SNAPSHOTS_SORT_BY,
    isValidSortField: isSnapshotsSortField,
    getSortBy: getSnapshotsSortBy
  });
}

/**
 * Converts a SortItem to a SnapshotsSortBy string
 * @param sortItem The sort item containing field and sort direction
 * @returns The SnapshotsSortBy string
 */
export function getSnapshotsSortBy(sortItem) {
  const {
    field,
    sort
  } = sortItem;
  const isAscending = sort === "asc";

  // Map the field values to the SnapshotsSortBy keys
  switch (field) {
    case "name":
      return isAscending ? "name_ascending" : "name_descending";
    case "created":
      return isAscending ? "created_ascending" : "created_descending";
    case "accessLevel":
      return isAscending ? "accessLevel_ascending" : "accessLevel_descending";
    default:
      {
        return DEFAULT_SNAPSHOTS_SORT_BY;
      }
  }
}

/**
 * Sorts an array of snapshots based on the provided sorting criteria.
 * @param snapshots - The array of snapshots to sort
 * @param sortBy - The sorting criteria
 * @returns A new sorted array of snapshots
 */
export function sortSnapshots(snapshots, sortBy) {
  const sorted = [...snapshots];
  sorted.sort((a, b) => {
    switch (sortBy) {
      case "name_ascending":
        return a.name.localeCompare(b.name);
      case "name_descending":
        return b.name.localeCompare(a.name);
      case "created_ascending":
        return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
      case "created_descending":
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      case "accessLevel_ascending":
        return a.accessLevel.localeCompare(b.accessLevel);
      case "accessLevel_descending":
        return b.accessLevel.localeCompare(a.accessLevel);
      default:
        return 0;
    }
  });
  return sorted;
}